import { SpotList } from "Domain/Model/SpotList/SpotList";

export const CREATE_SPOT_LIST_SUCCESS = 'CREATE_SPOT_LIST_SUCCESS';

export const createSpotListSuccess = (payload: Record<string, SpotList> ) => ({
    type: CREATE_SPOT_LIST_SUCCESS,
    payload,
});